import React, { useContext } from "react";
import { AppType } from "@/features/applications";

export const WLTabsContext = React.createContext<{
  selectedStocks: AppType.TickerExchange[];
  setSelectedStocks: (e: AppType.TickerExchange[]) => void;
  alertModal: boolean;
  setAlertModal: (e: boolean) => void;
}>({
  selectedStocks: [],
  setSelectedStocks: () => {},
  alertModal: false,
  setAlertModal: () => {}
});

export const useWLTabsContext = () => useContext(WLTabsContext);

export const useFilterWatchlistData = (data: AppType.TickerExchange[], ticker: string, exchange: string): boolean =>
  !!data.find(s => s.ticker === ticker && s.exchange === exchange);
